export default __webpack_public_path__ + "static/media/82g.71dafaca.svg";